<template>
  <Wrapper :type="type" @delete="$emit('delete')">
    <a slot="preview" v-text="data.href" :href="data.href" target="_blank"></a>
    <v-text-field
      slot="edition"
      :value="data.href"
      label="Link"
      box
      @input="setValue"
      :rules="[formRules.required, formRules.URL]"
    ></v-text-field>
  </Wrapper>
</template>

<script>
import Wrapper from "../../components/widgets/Wrapper";

export default {
  name: "Link",
  components: {
    Wrapper
  },
  model: {
    prop: "data"
  },
  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    setValue(href) {
      this.$emit("input", {
        href
      });
    }
  }
};
</script>
